import React from "react";

const TemplateTasksContext = React.createContext();

export default TemplateTasksContext;
